import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/AuthContext';

export default function SignUpPage() {
  const { signUp } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!name.trim()) { setError('Please enter your name.'); return; }
    if (!email.trim()) { setError('Please enter your email.'); return; }
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    setSubmitting(true);
    try {
      await signUp(email, password, name);
      navigate('/home', { replace: true });
    } catch (err) {
      setError(err.message || 'Could not create account.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: '#FBF6EF' }}>
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-6">
          <img src="/brand/logo-round.png" alt="Heritage Compass" className="w-20 h-20 rounded-full" data-testid="signup-logo" />
        </div>
        <h1 className="text-3xl font-extrabold mb-1" style={{ color: '#5B2D1F' }}>Create your account</h1>
        <p className="text-base mb-6" style={{ color: '#4B6B79' }}>Just a few details and you&apos;re ready to go.</p>

        {error && (
          <div data-testid="signup-error" className="p-4 rounded-xl border mb-4" style={{ backgroundColor: '#FCE7EA', borderColor: '#B0303A' }}>
            <p className="font-semibold" style={{ color: '#B0303A' }}>{error}</p>
          </div>
        )}

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label htmlFor="signup-name" className="block text-sm font-semibold mb-1" style={{ color: '#0F2A35' }}>Your name</label>
            <input id="signup-name" data-testid="signup-name-input" type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Margaret Doyle" className="w-full px-4 py-3 rounded-xl border text-base outline-none focus:ring-2" style={{ borderColor: '#D7E2E8', backgroundColor: '#FFFFFF' }} />
          </div>
          <div>
            <label htmlFor="signup-email" className="block text-sm font-semibold mb-1" style={{ color: '#0F2A35' }}>Email</label>
            <input id="signup-email" data-testid="signup-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" autoComplete="email" className="w-full px-4 py-3 rounded-xl border text-base outline-none focus:ring-2" style={{ borderColor: '#D7E2E8', backgroundColor: '#FFFFFF' }} />
          </div>
          <div>
            <label htmlFor="signup-password" className="block text-sm font-semibold mb-1" style={{ color: '#0F2A35' }}>Password</label>
            <input id="signup-password" data-testid="signup-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="At least 8 characters" className="w-full px-4 py-3 rounded-xl border text-base outline-none focus:ring-2" style={{ borderColor: '#D7E2E8', backgroundColor: '#FFFFFF' }} />
            <p className="text-xs mt-1" style={{ color: '#4B6B79' }}>Use 8+ characters with a mix of letters and numbers.</p>
          </div>
          <button type="submit" data-testid="signup-submit-btn" disabled={submitting} className="w-full py-4 rounded-xl text-lg font-extrabold text-white transition-opacity hover:opacity-90 disabled:opacity-50" style={{ backgroundColor: '#D77A52' }}>
            {submitting ? 'Creating…' : 'Create account'}
          </button>
        </form>

        <p className="text-center mt-6" style={{ color: '#4B6B79' }}>
          Already have an account?{' '}
          <Link to="/signin" data-testid="signup-go-signin" className="font-bold" style={{ color: '#D77A52' }}>Sign in</Link>
        </p>
        <p className="text-xs mt-6 text-center leading-relaxed" style={{ color: '#4B6B79' }}>
          By creating an account you acknowledge that Heritage Compass is for educational use only and is not a substitute for professional medical advice.
        </p>
      </div>
    </div>
  );
}
